module.exports = __webpack_public_path__ + "static/atl-black-tech-2a3ff3529c39fc20c2331074d9062fde.jpg";